var _rect, _path, _path2, _rect2, _path3, _path4, _path5, _path6, _rect3, _rect4, _rect5, _rect6, _path7, _path8, _path9, _path10, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeHealthIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 21.3335,
    y: 0.834229,
    width: 2.66667,
    height: 5.33333,
    fill: "#BBDEFB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 3L30.5 9.12679V30.5H16V3Z",
    fill: "#BBDEFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 9.12636L16 3V30.5H1.5V9.12636Z",
    fill: "#F1F8FE"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 30.5,
    width: 32,
    height: 1.5,
    rx: 0.75,
    fill: "#DBEDFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5525 10.3458C31.3481 10.7974 30.8189 10.9775 30.3832 10.7437L15.5847 2.80083C15.4152 2.70988 15.3485 2.49438 15.4369 2.3235C15.824 1.57549 16.7273 1.29884 17.4666 1.70195L31.1593 9.16867C31.5737 9.39463 31.7474 9.91481 31.5525 10.3458Z",
    fill: "#DBEDFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.546577 9.87362C0.300076 9.39756 0.491167 8.79732 0.968004 8.54987L14.9882 1.27441C15.598 0.957926 16.3154 0.97676 16.8944 1.32446L17.9898 1.98226L1.77562 10.2665C1.32239 10.4981 0.780163 10.3247 0.546577 9.87362Z",
    fill: "#B5DCFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19 19.562C19 19.2516 19.2516 19 19.562 19H26.938C27.2484 19 27.5 19.2516 27.5 19.562V30.5H19V19.562Z",
    fill: "#5085C9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 20.5H26V30.5H20.5V20.5Z",
    fill: "#BBDEFB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 19,
    width: 4,
    height: 4,
    fill: "#BBDEFB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 19,
    width: 4,
    height: 4,
    fill: "#BBDEFB"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 23.5,
    width: 4,
    height: 4,
    fill: "#BBDEFB"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 4.5,
    y: 23.5,
    width: 4,
    height: 4,
    fill: "#BBDEFB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.5C20 10.9979 19.5523 10.5909 19 10.5909H13C12.4477 10.5909 12 10.9979 12 11.5C12 12.0021 12.4477 12.4091 13 12.4091H19C19.5523 12.4091 20 12.0021 20 11.5Z",
    fill: "#F3858B"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M17 8.40909C17 7.90701 16.5523 7.5 16 7.5C15.4477 7.5 15 7.90701 15 8.40909V14.5909C15 15.093 15.4477 15.5 16 15.5C16.5523 15.5 17 15.093 17 14.5909V8.40909Z",
    fill: "#F3858B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_649_552",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 7,
    width: 8,
    height: 9
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M20 11.5C20 10.9979 19.5523 10.5909 19 10.5909H13C12.4477 10.5909 12 10.9979 12 11.5C12 12.0021 12.4477 12.4091 13 12.4091H19C19.5523 12.4091 20 12.0021 20 11.5Z",
    fill: "#F3858B"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17 8.40909C17 7.90701 16.5523 7.5 16 7.5C15.4477 7.5 15 7.90701 15 8.40909V14.5909C15 15.093 15.4477 15.5 16 15.5C16.5523 15.5 17 15.093 17 14.5909V8.40909Z",
    fill: "#F3858B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_649_552)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 7.5,
    width: 4,
    height: 8,
    fill: "#D0262E"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeHealthIcon);
export default __webpack_public_path__ + "static/media/Home-health-icon.72b95855e4de8b305ec25e9f97a1a57f.svg";
export { ForwardRef as ReactComponent };